module.exports = __webpack_public_path__ + "img/10000.a56d65e1.png";